(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tc-product-custom-options"] && !Shopify.designMode) return;
  try {
    (() => {
    const notSelected = 'Not selected';
    const notSpecified = 'Not specified';
    const noRequirements = 'None selected';
    const noteDefault = 'Finish images are indicative. Final polish will be confirmed before production.';
    const noteMatched = 'Showing uploaded product media for the selected finish.';

    function getCheckedValue(container, field) {
      return container.querySelector(`[data-tc-field="${field}"]:checked`)?.value || notSelected;
    }

    function getInputValue(container, field) {
      return container.querySelector(`[data-tc-field="${field}"]`)?.value.trim() || notSpecified;
    }

    function getRequirements(container) {
      const selected = Array.from(container.querySelectorAll('[data-tc-field="requirement"]:checked')).map((input) => input.value);
      return selected.length ? selected.join(', ') : noRequirements;
    }

    function buildSize(container) {
      const width = getInputValue(container, 'width');
      const depth = getInputValue(container, 'depth');
      const height = getInputValue(container, 'height');

      if (width === notSpecified && depth === notSpecified && height === notSpecified) return notSpecified;

      return `Width: ${width}; Depth / length: ${depth}; Height: ${height}`;
    }

    function updateWhatsApp(container) {
      const link = container.querySelector('[data-tc-whatsapp-link]');
      if (!link) return;

      const message = [
        'Hi Timbercraft, I would like a quote for this custom teak furniture.',
        '',
        `Product: ${container.dataset.productTitle || ''}`,
        `Link: ${container.dataset.productUrl || window.location.href}`,
        '',
        'Selected options:',
        `Wood finish: ${getCheckedValue(container, 'wood')}`,
        `Fabric / upholstery: ${getCheckedValue(container, 'fabric')}`,
        `Size: ${buildSize(container)}`,
        `Delivery city: ${getInputValue(container, 'city')}`,
        `Additional requirements: ${getRequirements(container)}`,
        '',
        'Please share price and timeline.',
      ].join('\n');

      link.href = `https://wa.me/${container.dataset.whatsappNumber || '918008078579'}?text=${encodeURIComponent(message)}`;
    }

    function selectUploadedMedia(input, container) {
      const note = container.querySelector('[data-tc-finish-note]');
      const mediaId = input.dataset.mediaId;

      if (!mediaId) {
        if (note) note.textContent = noteDefault;
        return;
      }

      const gallery = document.querySelector('media-gallery');
      const media = gallery?.querySelector(`.product-media[data-media-id="${mediaId}"]`);

      if (!gallery || !media) {
        if (note) note.textContent = noteDefault;
        return;
      }

      const slide = media.closest('slideshow-slide');
      if (slide && gallery.slideshow) {
        const slides = Array.from(gallery.querySelectorAll('slideshow-slide'));
        const index = slides.indexOf(slide);
        if (index >= 0) gallery.slideshow.select(index, undefined, { animate: true });
      }

      const gridItem = media.closest('.product-media-container');
      if (gridItem) gridItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      if (note) note.textContent = noteMatched;
    }

    function init(container) {
      if (container.dataset.tcProductOptionsReady === 'true') return;
      container.dataset.tcProductOptionsReady = 'true';

      container.addEventListener('input', () => updateWhatsApp(container));
      container.addEventListener('change', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement)) return;
        if (target.dataset.tcField === 'wood') selectUploadedMedia(target, container);
        updateWhatsApp(container);
      });

      updateWhatsApp(container);
    }

    function initAll(root = document) {
      root.querySelectorAll('[data-tc-product-custom-options]').forEach(init);
    }

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
